export const IMAGE_CONFIG = {
  homepageBanner: {
    label: 'Homepage Hero Banner',
    width: 1600,
    height: 600,
    aspectRatio: 16 / 6,
    aspectRatioLabel: '8:3',
    maxSizeMB: 10
  },
  productMain: {
    label: 'Product Cover Image',
    width: 1000,
    height: 1333,
    aspectRatio: 3 / 4,
    aspectRatioLabel: '3:4',
    maxSizeMB: 10
  },
  productGallery: {
    label: 'Product Gallery Image',
    width: 1000,
    height: 1333,
    aspectRatio: 3 / 4,
    aspectRatioLabel: '3:4',
    maxSizeMB: 10
  },
  category: {
    label: 'Category Image',
    width: 500,
    height: 500,
    aspectRatio: 1 / 1,
    aspectRatioLabel: '1:1',
    maxSizeMB: 5
  },
  parentCategory: {
    label: 'Parent Category Image',
    width: 500,
    height: 500,
    aspectRatio: 1 / 1,
    aspectRatioLabel: '1:1',
    maxSizeMB: 5
  },
  categoryIcon: {
    label: 'Category Icon',
    width: 256,
    height: 256,
    aspectRatio: 1 / 1,
    aspectRatioLabel: '1:1',
    maxSizeMB: 5
  },
  categoryBanner: {
    label: 'Category Header Banner',
    width: 1200,
    height: 400,
    aspectRatio: 3 / 1,
    aspectRatioLabel: '3:1',
    maxSizeMB: 8
  },
  brandLogo: {
    label: 'Brand Logo',
    width: 400,
    height: 400,
    aspectRatio: 1 / 1,
    aspectRatioLabel: '1:1',
    maxSizeMB: 5
  }
};
